import CostHTMLPreviewBaseSection from './CostHTMLPreviewBaseSection'

export default function CostHTMLPreviewGrandTotalSection() {}

CostHTMLPreviewGrandTotalSection.prototype = new CostHTMLPreviewBaseSection();

CostHTMLPreviewGrandTotalSection.prototype.init = function( columnsStrategy )
{
    CostHTMLPreviewBaseSection.prototype.init.call( this, columnsStrategy );
    return this;
};

CostHTMLPreviewGrandTotalSection.prototype.addRows = function( tBody )
{
    var splitterRow = this.createRow("splitterRow");
    this.addCell( splitterRow, "", "", this.columnsStrategy.getDataColumnsCount() + 1 );
    this.addRow( tBody, splitterRow );

    this.addRowWithMainCell( tBody, this.message("report.grand_total"), "grandTotalCell", "grandTotal" )
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/cost/CostHTMLPreviewGrandTotalSection.js